import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        flex: 1,
        backgroundColor: Theme.primaryBackgroundColor,
        paddingHorizontal: Theme.primaryMargin,
        backgroundColor: 'transparent'
        // alignItems: 'center',
        // maxWidth: '80%'
    },
    webContainer: {},
    innerContainer: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1
    },
    scrollWrapper: {
        flex: 1,
        alignItems: 'center',
        flexGrow: 1,
        flexDirection: 'row'
    },
    titleContainer: {
        flexDirection: 'column',
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center'
    },
    titleContainerLandscape: {
        flexDirection: 'row'
    },
    infoIcon: {
        width: 20,
        height: 20,
        marginBottom: 10
    },
    infoIconLandscape: {
        marginLeft: Theme.BU,
        marginRight: Theme.BU,
        marginBottom: Theme.BU
    },
    title: {
        fontFamily: Theme.regularFont,
        fontSize: 38,
        marginHorizontal: 18,
        marginBottom: 10,
        color: Theme.primaryTextColor,
        textAlign: 'center',
        fontWeight: 'bold'
    },
    message: {
        fontFamily: Theme.regularFont,
        marginVertical: 25,
        color: Theme.secondaryTextColor,
        fontSize: 18,
        textAlign: 'center'
    },
    hr: {
        marginBottom: 20
    },
    iconContainerLandscape: {
        marginTop: 17,
        paddingHorizontal: 0,
        alignItems: 'flex-start'
    },
    buttonsContainer: {
        alignSelf: 'stretch',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: 10
    },
    buttonContainerOneButton: {
        justifyContent: 'center'
    },
    button: {
        margin: Theme.BU / 2
    },
    confirmLabelContainer: { width: 250 },
    landscapeButtonsContainer: {
        flexDirection: 'row-reverse'
    },
    logo: {
        alignSelf: 'center',
        width: 38,
        height: 38
    },
    constainerTile: {
        width: '80%',
        borderRadius: 10,
        backgroundColor: 'rgba(252, 252, 252, 0.1)',
        padding: 10,
        marginVertical: 10
    },
    rowElement: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
        marginLeft: 10
    },
    suggestionText: {
        color: 'white',
        fontWeight: '500',
        fontSize: 18,
        paddingVertical: 15
    },
    constainerTileTablet: {},
    mainContainer: {},
    imageBackground: {},
    contentContainer: {}
};

if (Device.isTablet) {
    baseStyles = {
        ...baseStyles,
        innerContainer: {
            ...baseStyles.innerContainer,
            marginHorizontal: '10%'
        },
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            flexDirection: 'row-reverse'
        },
        infoIcon: {
            ...baseStyles.infoIcon,
            marginRight: 15,
            marginBottom: 15
        },
        containerItem: {
            ...baseStyles.containerItem,
            minWidth: 225
        },
        constainerTile: {
            flexDirection: 'row',
            justifyContent: 'space-around',
            width: '100%',
            marginVertical: 10
        },
        constainerTileTablet: {
            width: 230,
            height: 230,
            borderRadius: 10,
            backgroundColor: 'rgba(252, 252, 252, 0.1)',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 10,
            flexDirection: 'column'
        },
        suggestionText: {
            color: 'white',
            fontWeight: '500',
            fontSize: 18,
            textAlign: 'center'
        }
    };
}

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        innerContainer: {
            ...baseStyles.innerContainer,
            marginHorizontal: '10%'
        },
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            flexDirection: 'row-reverse'
        },
        infoIcon: {
            ...baseStyles.infoIcon,
            marginRight: 15,
            marginBottom: 15
        },
        containerItem: {
            ...baseStyles.containerItem,
            minWidth: 225
        },
        constainerTile: {
            flexDirection: 'row',
            justifyContent: 'space-around',
            width: '100%',
            marginVertical: 10
        },
        constainerTileTablet: {
            width: 230,
            height: 230,
            borderRadius: 10,
            backgroundColor: 'rgba(252, 252, 252, 0.1)',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 10,
            flexDirection: 'column'
        },
        suggestionText: {
            color: 'white',
            fontWeight: '500',
            fontSize: 18,
            textAlign: 'center'
        },
        mainContainer: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            paddingVertical: '5%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
        },
        imageBackground: {
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'transparent'
        }
    };
}

export default StyleSheet.create(baseStyles);
